import { useState } from "react";
import {
  Box,
  Checkbox,
  Typography,
  Tabs,
  Tab,
  Divider,
  Button,
  Menu,
  MenuItem,
  TextField,
  Modal,
  Tooltip,
  CircularProgress,
} from "@material-ui/core";
import useStyles from "./TaskToDos.styles";
import {
  DotsThree,
  Plus,
  Trash,
  PencilLine,
  Check,
  X,
  Warning,
  CheckCircle,
  CheckSquareOffset,
} from "phosphor-react";
import DeleteModal from "../DeleteModal/DeleteModal.component";
import { fdelete, fpatch, fpost } from "../../../API/callsAPI";
import DateAndTimeViewer from "../DateAndTimeViewer/DateAndTimeViewer.component";
import NoResultFound from "../NoResultFound/NoResultFound";

export default function TaskToDos({
  linkedTask,
  checkList,
  updateRefreshChecklist,
  currentTab,
  onChangeTab,
  version_type,
  selectedVersion,
  isDataLoading,
  toDoType,
  isTaskDetailsExpanded,
  projectId,
}) {
  const classes = useStyles();

  const [addToDo, setAddToDo] = useState(false);
  const [taskToDo, setTaskToDo] = useState("");
  const [completed, setCompleted] = useState(false);
  const [addVersion, setAddVersion] = useState(false);

  const addNewListItem = async () => {
    if (taskToDo) {
      let obj = {
        title: taskToDo,
        task: linkedTask.id,
        completed: completed,
        project: projectId,
      };
      if (addVersion && toDoType === "versionVeiwer") {
        obj["version_start_id"] = selectedVersion.id;
        obj["version_start_content_type"] = version_type;
      }
      if (completed && toDoType === "versionVeiwer") {
        obj["version_end_id"] = selectedVersion.id;
        obj["version_end_content_type"] = version_type;
      }
      try {
        const res = await fpost({
          url: `trackables/checklist-items/`,
          data: [obj],
        });
        if (res.status == 200 || res.status == 201) {
          updateRefreshChecklist();
          handleReset();
        }
      } catch (error) {
        console.log(error);
      }
    } else {
      handleReset();
    }
  };

  const handleReset = () => {
    setTaskToDo("");
    setAddVersion(false);
    setCompleted(false);
  };

  const handleAddToDo = () => {
    setAddToDo(!addToDo);
  };
  function handleKeyDown(event) {
    event.stopPropagation();
  }

  return (
    <Box style={{ height: "100%", width: "100%" }}>
      <div className={classes.spaceBetween}>
        <Tabs
          value={currentTab}
          onChange={(event, value) => {
            onChangeTab(value);
          }}
        >
          <Tab
            className={
              currentTab === "active" ? classes.tabActive : classes.tabInactive
            }
            value={"active"}
            id="active"
            label="Active"
          />
          <Tab
            className={
              currentTab === "completed"
                ? classes.tabActive
                : classes.tabInactive
            }
            value={"completed"}
            id="completed"
            label="Completed"
          />
        </Tabs>
        <Typography>To Do's: {checkList?.checklist_items?.length}</Typography>
      </div>
      <Divider className={classes.divider} />
      {!isDataLoading ? (
        checkList?.checklist_items?.length > 0 ? (
          <div
            className={
              currentTab === "active"
                ? toDoType === "taskPage"
                  ? isTaskDetailsExpanded
                    ? classes.activeTaskContainerExpanded
                    : classes.activeTaskContainer
                  : classes.activeContainer
                : classes.inactiveContainer
            }
          >
            {checkList?.checklist_items?.map((checklistitem) => {
              return (
                <SingleToDo
                  updateRefreshChecklist={updateRefreshChecklist}
                  currentTab={currentTab}
                  key={checklistitem.id}
                  singleCheckList={checklistitem}
                  selectedVersion={selectedVersion}
                  version_type={version_type}
                  toDoType={toDoType}
                  linkedTask={linkedTask}
                />
              );
            })}
          </div>
        ) : (
          <div style={{ marginTop: "30px" }}>
            <NoResultFound />
          </div>
        )
      ) : (
        <div
          style={{
            height: "40%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <CircularProgress color="secondary" />
        </div>
      )}
      {addToDo && currentTab === "active" && (
        <div>
          <div className={classes.spaceBetween}>
            <div
              className={classes.header}
              style={{ width: "100%" }}
              onKeyDown={handleKeyDown}
            >
              <Checkbox
                checked={completed}
                onChange={(event) => setCompleted(event.target.checked)}
              />
              <TextField
                InputProps={{ disableUnderline: true }}
                style={{ width: "80%" }}
                value={taskToDo}
                onChange={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  setTaskToDo(e.target.value);
                }}
              />
            </div>
            <div className={classes.header}>
              <Button
                onClick={() => {
                  handleAddToDo();
                  addNewListItem();
                }}
              >
                <Check size={18} />
              </Button>
              <Button
                onClick={() => {
                  handleAddToDo();
                  handleReset();
                }}
              >
                <X color="#F40A0A" size={18} />
              </Button>
            </div>
          </div>
          {toDoType === "versionVeiwer" && (
            <div className={classes.linkVersion}>
              <Checkbox
                size="small"
                checked={addVersion}
                onChange={(event) => setAddVersion(event.target.checked)}
              />
              <span>Link Version</span>
            </div>
          )}
        </div>
      )}

      {currentTab === "active" && (
        <div className={classes.center}>
          <Button
            onClick={handleAddToDo}
            className={classes.addToDoButton}
            startIcon={<Plus />}
            disabled={!linkedTask?.id}
          >
            Add a To Do
          </Button>
        </div>
      )}
    </Box>
  );
}

const SingleToDo = ({
  singleCheckList,
  updateRefreshChecklist,
  selectedVersion,
  version_type,
  currentTab,
  toDoType,
  linkedTask,
}) => {
  const classes = useStyles();
  const [showButtons, setShowButtons] = useState(null);
  const [text, setText] = useState(singleCheckList.title);
  const [isEditing, setEditing] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [linkVersion, setLinkVersion] = useState(
    singleCheckList.version_start ? true : false
  );

  const handleDelteModal = () => {
    setIsDeleteModalOpen(!isDeleteModalOpen);
  };

  const handleEditing = () => {
    setEditing(!isEditing);
  };
  function handleKeyDown(event) {
    event.stopPropagation();
  }

  const handleEditToDo = async (completed) => {
    let obj = {};
    if (text && text !== singleCheckList.title) {
      obj["title"] = text;
    }
    if (completed) {
      obj["completed"] = !singleCheckList.completed;
      if (toDoType === "versionVeiwer") {
        obj["version_end_id"] = !singleCheckList.completed
          ? selectedVersion.id
          : null;
        obj["version_end_content_type"] = !singleCheckList.completed
          ? version_type
          : null;
      }
    }
    if (
      toDoType === "versionVeiwer" &&
      linkVersion !== (singleCheckList.version_start ? true : false)
    ) {
      linkVersion
        ? (obj["version_start_id"] = selectedVersion.id)
        : (obj["version_start_id"] = null);
      linkVersion
        ? (obj["version_start_content_type"] = version_type)
        : (obj["version_start_content_type"] = null);
    }
    try {
      const res = await fpatch({
        url: `trackables/checklist-items/${singleCheckList.id}/`,
        data: obj,
      });
      if (res.status === 200 || res.status === 201) {
        setShowButtons(null);
        !completed && handleEditing();
        updateRefreshChecklist();
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleDeleteToDo = async () => {
    try {
      const res = await fdelete({
        url: `trackables/checklist-items/${singleCheckList.id}/`,
      });
      setShowButtons(null);
      handleDelteModal();
      updateRefreshChecklist();
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <Box style={{ fontSize: "14px" }}>
      <div className={classes.spaceBetween}>
        <div
          className={classes.header}
          style={{ width: "100%" }}
          onKeyDown={handleKeyDown}
        >
          {!isEditing && (
            <Checkbox
              checked={singleCheckList.completed}
              onChange={(event) => handleEditToDo("completed")}
            />
          )}
          {isEditing ? (
            <TextField
              InputProps={{ disableUnderline: true }}
              style={{ width: "80%", marginLeft: "45px" }}
              value={text}
              onChange={(e) => {
                e.preventDefault();
                e.stopPropagation();
                setText(e.target.value);
              }}
              inputProps={{
                fontSize: "14px !important",
              }}
            />
          ) : (
            <Typography style={{ fontSize: "14px !important" }}>
              {singleCheckList.title}
            </Typography>
          )}
        </div>
        {isEditing ? (
          <div className={classes.header}>
            <Button
              onClick={() => {
                handleEditToDo();
              }}
            >
              <Check size={18} />
            </Button>
            <Button
              onClick={() => {
                handleEditing();
                setText(singleCheckList.title);
                setLinkVersion(singleCheckList.version_start ? true : false);
              }}
            >
              <X color="#F40A0A" size={18} />
            </Button>
          </div>
        ) : currentTab === "completed" ? (
          <Button onClick={handleDelteModal}>
            <Trash color="#F40A0A" size={18} />
          </Button>
        ) : (
          <Button onClick={(e) => setShowButtons(e.currentTarget)}>
            <DotsThree size={20} />
          </Button>
        )}
      </div>
      <div className={classes.spaceBetween}>
        <div className={`${classes.header} ${classes.versionName}`}>
          {singleCheckList.version_start || singleCheckList.version_end ? (
            <>
              {singleCheckList.version_start && (
                <>
                  <Warning size={18} weight="fill" />{" "}
                  <Tooltip title={singleCheckList.version_start?.name}>
                    <span
                      style={{
                        maxWidth: singleCheckList.version_end ? "40%" : "100%",
                        overflow: "hidden",
                        whiteSpace: "nowrap",
                        textOverflow: "ellipsis",
                      }}
                    >
                      {singleCheckList.version_start?.name}
                    </span>
                  </Tooltip>
                </>
              )}
              {singleCheckList.version_end && (
                <>
                  <CheckCircle size={18} weight="fill" color="#44B927" />
                  <Tooltip title={singleCheckList.version_end?.name}>
                    <span
                      style={{
                        maxWidth: singleCheckList.version_start
                          ? "40%"
                          : "100%",
                        overflow: "hidden",
                        whiteSpace: "nowrap",
                        textOverflow: "ellipsis",
                        color: "#44B927",
                      }}
                    >
                      {singleCheckList.version_end?.name}
                    </span>
                  </Tooltip>
                </>
              )}
            </>
          ) : (
            <>
              <CheckSquareOffset size={18} weight="fill" />
              <Typography>{linkedTask?.name}</Typography>
            </>
          )}
        </div>
        {isEditing && toDoType === "versionVeiwer" ? (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "flex-end",
              fontSize: "12px",
            }}
          >
            <Checkbox
              style={{ padding: "3px" }}
              size="small"
              checked={linkVersion}
              onChange={(event) => setLinkVersion(event.target.checked)}
            />
            Link Version
          </div>
        ) : (
          <Typography className={classes.tertiaryColor}>
            <DateAndTimeViewer dateAndTime={singleCheckList.created_at} />
          </Typography>
        )}
      </div>
      <Menu
        anchorEl={showButtons}
        open={Boolean(showButtons)}
        onClose={() => {
          setShowButtons(null);
        }}
        MenuListProps={{ className: `${classes.menuPop}` }}
      >
        <MenuItem
          className={classes.menuItem}
          onClick={() => {
            handleEditing();
            setShowButtons(null);
          }}
        >
          <PencilLine size={25} />
          <span>Edit To-Do</span>
        </MenuItem>
        <Divider />
        <MenuItem
          onClick={handleDelteModal}
          className={`${classes.menuItem} ${classes.deleteColor}`}
        >
          <Trash size={25} className={classes.deleteIcon} />
          <span>Delete To-Do</span>
        </MenuItem>
      </Menu>
      <Modal
        className={classes.center}
        open={isDeleteModalOpen}
        onClose={handleDelteModal}
      >
        <DeleteModal
          type="Task to do"
          name={singleCheckList.title}
          handleCloseDeleteModal={handleDelteModal}
          handleDelete={handleDeleteToDo}
        />
      </Modal>
    </Box>
  );
};
